import OrderStatusChip from '../../OrderStatus/OrderStatusСhip';

import styles from './CabinetOrders.module.scss';
import { OrdersQuery } from '../../../__generated__/graphql';
import { Button } from '../../Button/Button';
import { formatDateMonthShort } from '../../../features/date';

type Props = {
  orders: OrdersQuery['orders']['data'];
};

const CabinetOrders = ({ orders }: Props) => {
  return orders ? (
    <div className={styles.ordersContainer}>
      {orders.map((order) => (
        <div className={styles.orderCard} key={order.id}>
          <div className={styles.orderNum}>№ {order.num} от {formatDateMonthShort(new Date(order.created_at))}</div>
          <OrderStatusChip status={order.status} />
          <div className={styles.orderBtn}>
            <Button
              type='link'
              href={`/cabinet/orders/${order.id}`}
              variant='outlined-mini'
            >
              Открыть
            </Button>
          </div>
        </div>
      ))}
      <Button variant='outlined-mini' href='/cabinet/orders' type='link'>
        Смотреть все
      </Button>
    </div>
  ) : (
    <p>У Вас нет активных заказов</p>
  );
};

export default CabinetOrders;
